<template>
  <div class="p-12" >
    <template v-for="v in visibleFields" :key="v.key">
      <div class=" m-b-15" :class="v.key!='video'&&v.key!='video_is_show'?'s_flex_ali':''" style="  color:#131313;">
        <div class="label">{{v.label}}：</div>
        <div v-if="v.key=='video_is_show'">
          <img src="@/assets/images/normal.png" alt="" style="width:100%;margin-top:10px">
        </div>
        <div class="content s_omit s_flex_ali" v-else-if="v.key!='video'" >
          <div>
            <div> {{v.defaultText}} </div>
          </div>
          <div v-if="v.key=='server_phone'&&(data.params.is_show_call===true||data.params.is_show_call==1)"   :style="'color:'+gobleStyle.themeColor+';border-color:'+gobleStyle.themeColor" ><PhoneFilled class="m-r-3 m-l-10" /></div>
          <div v-if="v.key=='inspection_report'">
              <img src="@/assets/images/normal.png" alt="" style="width:80px;margin-right:10px">
              <img src="@/assets/images/normal.png" alt="" style="width:80px;margin-right:10px">
              <img src="@/assets/images/normal.png" alt="" style="width:80px;margin-right:10px">
          </div>
        </div>
        <div v-else style="	overflow-x:auto;white-space:nowrap;" class="m-t-10">
          <div style="display:inline-block;" class="m-r-5 width-100 videoContent ">
            <img src="@/assets/images/scan/traceVideo.jpg" alt="" class="width-100 height-80 m-b-5 s_bor5" style="display:block;">
            <span class="fz-12 s_c13">种植基地</span>
          </div>
          <div style="display:inline-block;" class="m-r-5 width-100 videoContent s_bor10">
            <img src="@/assets/images/scan/traceVideo.jpg" alt="" class="width-100 height-80 m-b-5 s_bor5" style="display:block;">
            <span class="fz-12 s_c13">生产基地</span>
          </div>
          <div style="display:inline-block" class="m-r-5 width-100 videoContent s_bor10">
            <img src="@/assets/images/scan/traceVideo.jpg" alt="" class="width-100 height-80 m-b-5 s_bor5" style="display:block;">
            <span class="fz-12 s_c13">仓储基地</span>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import {PhoneFilled} from "@ant-design/icons-vue";
import { computed } from 'vue';
import { tracePreviewFields } from '../../traceFields';
export default {
  props: { data: Object,gobleStyle:Object },
  components:{PhoneFilled},
  setup(props) {
    return {
      visibleFields: computed(() => tracePreviewFields(props.data)),
    };
  },
};
</script>

<style lang="less" scoped>
.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
}
.content {
  flex: 1;
}
.videoContent {
  position: relative;
  &::before {
    content: "";
    background-image: url("../../../../../../../../assets/images/scan/play.png");
    background-size: cover;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>


